var _a;
import { ENTITY_MANAGEMENT_ENDPOINT, FILING_ENDPOINTS, INFO_PRODUCT_ENDPOINTS, } from '../../utilities/constants/api';
import { GOOGLE_RECAPTCHA_TOKEN_HEADER } from '../../utilities/constants/federatedSearch';
import Axios from '../../utilities/functions/axios';
const isRecaptchaDisabled = ((_a = process.env.REACT_APP_RECAPTCHA_ENABLE) === null || _a === void 0 ? void 0 : _a.toString()) === 'false';
export const getConfigWithRecaptcha = (reCaptchaToken) => isRecaptchaDisabled || !reCaptchaToken
    ? {}
    : { headers: { [GOOGLE_RECAPTCHA_TOKEN_HEADER]: reCaptchaToken } };
export const getConfigurationsSearch = async () => {
    const res = await Axios.get(`${INFO_PRODUCT_ENDPOINTS.getConfigurationsSearch}`);
    return res === null || res === void 0 ? void 0 : res.data;
};
export const postPeople = async (body, reCaptchaToken) => {
    const config = getConfigWithRecaptcha(reCaptchaToken);
    const res = await Axios.post(INFO_PRODUCT_ENDPOINTS.postPeople, body, config);
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getProductDataByCode = async (params, reCaptchaToken) => {
    const config = getConfigWithRecaptcha(reCaptchaToken);
    const res = await Axios.get(INFO_PRODUCT_ENDPOINTS.getProductDataByCode, {
        params,
        ...config,
    });
    return res === null || res === void 0 ? void 0 : res.data;
};
export const postProductDownload = async (body) => {
    const res = await Axios.post(INFO_PRODUCT_ENDPOINTS.postProductDownload, body);
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getProductDataStatus = async (code, deliveryEmail) => {
    const res = await Axios.get(INFO_PRODUCT_ENDPOINTS.getProductDataStatus(code, deliveryEmail));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const postSearchEntites = async (searchParams, reCaptchaToken) => {
    const config = getConfigWithRecaptcha(reCaptchaToken);
    const res = await Axios.post(INFO_PRODUCT_ENDPOINTS.postSearchEntities, searchParams, config);
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getBusinessProfile = async (type, uen) => {
    const res = await Axios.get(INFO_PRODUCT_ENDPOINTS.getBusinessProfile(type, uen));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getFinancialProfile = async (type) => {
    const res = await Axios.get(INFO_PRODUCT_ENDPOINTS.getFinancialProfile(type));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getCertificate = async (uen) => {
    const res = await Axios.get(INFO_PRODUCT_ENDPOINTS.getCertificate(uen));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getRegisters = async (uen) => {
    const res = await Axios.get(INFO_PRODUCT_ENDPOINTS.getRegisters(uen));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const postSearchIndustry = async (searchParams, reCaptchaToken) => {
    let param;
    if ('ssic' in searchParams) {
        const { ssic, ...rest } = searchParams;
        param = {
            ...rest,
            ssicCodes: ssic,
        };
    }
    else {
        param = { ...searchParams };
    }
    const config = getConfigWithRecaptcha(reCaptchaToken);
    const res = await Axios.post(INFO_PRODUCT_ENDPOINTS.postSearchIndustry, param, config);
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getPreviousKnownEntity = async (entityProfileId) => {
    const res = await Axios.get(ENTITY_MANAGEMENT_ENDPOINT.getEntityFormerName(entityProfileId));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getAnnualFilling = async (entityProfileId) => {
    const res = await Axios.get(FILING_ENDPOINTS.getAnnualFilling(entityProfileId));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getLodgementPeriod = async () => {
    const res = await Axios.get(INFO_PRODUCT_ENDPOINTS.getLodgementPeriod);
    return res === null || res === void 0 ? void 0 : res.data;
};
export const postReservedName = async (body, reCaptchaToken) => {
    let paramReserved;
    if ('ssic' in body) {
        const { ssic, ...rest } = body;
        paramReserved = {
            ...rest,
            ssicCodes: ssic,
        };
    }
    else {
        paramReserved = { ...body };
    }
    const config = getConfigWithRecaptcha(reCaptchaToken);
    const res = await Axios.post(INFO_PRODUCT_ENDPOINTS.postReservedNamesSearch, paramReserved, config);
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getProductAuthentication = async (authNo, identifierId, reCaptchaToken) => {
    const res = await Axios.get(INFO_PRODUCT_ENDPOINTS.getProductAuthentication(authNo, identifierId), { headers: { [GOOGLE_RECAPTCHA_TOKEN_HEADER]: reCaptchaToken } });
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getDownloadAll = async (downloadCode, deliveryEmail) => {
    const res = await Axios.get(INFO_PRODUCT_ENDPOINTS.getDownloadAll(downloadCode, deliveryEmail));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getEntityRestrictions = async (uen) => {
    const res = await Axios.get(INFO_PRODUCT_ENDPOINTS.getEntityRestrictions(uen));
    return res === null || res === void 0 ? void 0 : res.data;
};
